import { QueryClient } from '@tanstack/react-query';

export default function GetQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 20 * 1000, // milliseconds
        retry: 10, // retry up to this many times
        retryDelay: retryAttempt => retryAttempt * 1000, // will increase delay by 1 second on retry
        cacheTime: 30 * 60 * 1000,
      },
    },
  });
}


export function GetDeepComparedData(oldData, newData) {
  if (JSON.stringify(oldData) == JSON.stringify(newData))
    return oldData;
  else
    return newData;
}